import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";
import Logo from "./Logo";
import { scrollToId } from "../lib/scroll";
import { WHATSAPP_DISPLAY, whatsappLink } from "../lib/api";

const LINKS = [
  { label: "Catalog", target: "#catalog" },
  { label: "Calculator", target: "#calculator" },
  { label: "Liberia", target: "#liberia" },
  { label: "Process", target: "#process" },
];

const Navbar = ({ onQuote }) => {
  const [open, setOpen] = useState(false);

  const go = (target) => {
    setOpen(false);
    setTimeout(() => scrollToId(target), open ? 250 : 0);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="bg-[#141312] text-[#FAF8F5]">
        <div className="mx-auto max-w-7xl px-5 lg:px-8 h-9 flex items-center justify-between text-[11px] tracking-[0.14em] uppercase">
          <span className="font-medium text-[#D4AF37]">Mines &amp; Sales HQ — Liberia</span>
          <a
            data-testid="nav-whatsapp-link"
            href={whatsappLink("Hello Pacific Gold, I would like to inquire about a wholesale gold order")}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex items-center gap-2 hover:text-[#D4AF37] transition-colors duration-300"
          >
            <Phone size={12} /> {WHATSAPP_DISPLAY}
          </a>
          <span className="text-[#FAF8F5]/70 hidden md:inline">Min. wholesale order 500 g</span>
        </div>
      </div>
      <nav className="backdrop-blur-md bg-[#FAF8F5]/85 border-b border-[#E6E0D4]">
        <div className="mx-auto max-w-7xl px-5 lg:px-8 h-16 flex items-center justify-between">
          <button data-testid="nav-logo-home" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="cursor-pointer">
            <Logo />
          </button>
          <div className="hidden lg:flex items-center gap-8">
            {LINKS.map((l) => (
              <button
                key={l.target}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                onClick={() => go(l.target)}
                className="text-[13px] font-medium tracking-[0.16em] uppercase text-[#1A1816]/70 hover:text-[#8C6D27] transition-colors duration-300 relative group"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#C5A059] transition-all duration-500 group-hover:w-full" />
              </button>
            ))}
            <Button
              data-testid="nav-request-quote-button"
              onClick={onQuote}
              className="rounded-none bg-[#141312] text-[#FAF8F5] hover:bg-[#8C6D27] text-[13px] tracking-[0.14em] uppercase px-6 h-11 transition-colors duration-500"
            >
              Request Quote
            </Button>
          </div>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2 text-[#1A1816]"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
              className="lg:hidden overflow-hidden border-t border-[#E6E0D4] bg-[#FAF8F5]"
            >
              <div className="px-5 py-6 flex flex-col gap-5">
                {LINKS.map((l) => (
                  <button
                    key={l.target}
                    onClick={() => go(l.target)}
                    className="text-left text-sm font-medium tracking-[0.16em] uppercase text-[#1A1816]"
                  >
                    {l.label}
                  </button>
                ))}
                <Button
                  data-testid="nav-mobile-quote-button"
                  onClick={() => {
                    setOpen(false);
                    onQuote();
                  }}
                  className="rounded-none bg-[#141312] text-[#FAF8F5] hover:bg-[#8C6D27] text-[13px] tracking-[0.14em] uppercase h-12"
                >
                  Request Quote
                </Button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </header>
  );
};

export default Navbar;
